import React from "react";
import useResponsiveFlags from "../hooks/useResponsiveFlags";
import { Link } from "react-router-dom";

export default function WelcomeBack(props) {
  const { isDesktopLogin } = useResponsiveFlags();

  return (
    <>
      <p className="screen-title mx-0 pt-0">Dashboard</p>
      <div className="text-white hero-section" >
        <p style={{fontSize:"24px"}}>Welcome back, {props.data.fname}</p>

        <div
          className={`${
            !isDesktopLogin ? "" : "d-flex justify-content-between"
          }`}
          style={{ marginTop: "59px" }}
        >
          <p style={{ maxWidth: !isDesktopLogin ? "" : "40%" }}>
            iSort&trade; is a robust, AI-powered digital cytometry platform for
            accurate, high throughput cellular profiling — based on the most
            widely used and validated technology in the field.
          </p>
          <div style={{alignContent:"center", maxWidth: "fit-content"}}>
            <Link to="/fractions" className="btn learn-btn" style={{marginBottom: "0.5rem"}}>
              Learn More about iSort&trade; Fractions
            </Link>
            <Link to="/hires" className="btn learn-btn">
              Learn More about iSort&trade; HiRes
            </Link>
          </div>
        </div>
      </div>
    </>
  );
}
